var _clipPath, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHelp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-4.32571,-3.04791)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 54.326,
    cy: 53.048,
    r: 45.674,
    style: {
      fill: "none"
    }
  }), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip1"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 54.326,
    cy: 53.048,
    r: 45.674
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip1)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.823535,0,0,0.823535,34.8059,12.6209)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.248,47.033C23.925,45.857 26.818,44.584 28.928,43.212C31.038,41.841 32.545,40.304 33.449,38.601C34.354,36.898 34.806,34.901 34.806,32.61C34.806,29.083 33.781,26.461 31.731,24.743C29.682,23.025 26.532,22.166 22.282,22.166C17.821,22.166 13.647,22.965 9.759,24.562L9.759,17.283C11.446,16.56 13.526,15.98 15.998,15.543C18.469,15.106 20.896,14.887 23.277,14.887C29.848,14.887 34.843,16.341 38.264,19.25C41.685,22.159 43.396,26.356 43.396,31.841C43.396,36.453 42.183,40.311 39.756,43.416C37.33,46.52 33.449,49.157 28.114,51.328L27.301,64.936L21.74,64.936L20.248,47.033ZM24.543,83.292C22.734,83.292 21.265,82.75 20.135,81.665C19.004,80.58 18.439,79.148 18.439,77.37C18.439,75.561 18.997,74.114 20.112,73.029C21.227,71.944 22.704,71.402 24.543,71.402C26.351,71.402 27.813,71.952 28.928,73.052C30.043,74.152 30.601,75.591 30.601,77.37C30.601,79.118 30.043,80.542 28.928,81.642C27.813,82.742 26.351,83.292 24.543,83.292Z",
    style: {
      fillRule: "nonzero"
    }
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.326,7.374C79.534,7.374 100,27.84 100,53.048C100,78.256 79.534,98.722 54.326,98.722C29.117,98.722 8.651,78.256 8.651,53.048C8.651,27.84 29.117,7.374 54.326,7.374ZM54.326,10.374C77.878,10.374 97,29.495 97,53.048C97,76.6 77.878,95.722 54.326,95.722C30.773,95.722 11.651,76.6 11.651,53.048C11.651,29.495 30.773,10.374 54.326,10.374Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelp);
export default __webpack_public_path__ + "static/media/help.e82e50252131515baf5e14a9c8a27cc9.svg";
export { ForwardRef as ReactComponent };